import type { RouteObject } from 'react-router-dom';

import { lazy, Suspense } from 'react';

const PrivacyPage = lazy(() =>
  import('./pages/privacy-page').then((m) => ({ default: m.PrivacyPage })),
);
const TermsPage = lazy(() => import('./pages/terms-page').then((m) => ({ default: m.TermsPage })));

export const legalRoutes: RouteObject[] = [
  {
    path: 'legal/privacy',
    element: (
      <Suspense fallback={null}>
        <PrivacyPage />
      </Suspense>
    ),
  },
  {
    path: 'legal/terms',
    element: (
      <Suspense fallback={null}>
        <TermsPage />
      </Suspense>
    ),
  },
];
